import React, {FC} from 'react'
import {useTranslation} from '@wix/yoshi-flow-editor'
import {Text} from 'wix-ui-tpa/cssVars'
import type {CancellationPolicy} from '@wix/ambassador-table-reservations-v1-reservation-location/types'

import {classes} from './Form.st.css'

interface CancellationPolicyDisclosureProps {
  cancellationPolicy: CancellationPolicy | undefined | null
  isCancellationPolicyActive: boolean
  isCancellationFeeEnabled: boolean
}

export const CancellationPolicyDisclosure: FC<CancellationPolicyDisclosureProps> = ({
  cancellationPolicy,
  isCancellationPolicyActive,
  isCancellationFeeEnabled,
}) => {
  const {t} = useTranslation()

  if (
    isCancellationFeeEnabled ||
    !isCancellationPolicyActive ||
    !cancellationPolicy?.cancellationFee
  ) {
    return null
  }

  return (
    <div className={classes.cancellationPolicyDisclosure}>
      <Text className={classes.cancellationPolicyTitle} tagName="p">
        {t('uou-reservations.reservation-details.cancellation-policy.title')}
      </Text>
      {cancellationPolicy?.guestPolicy ? (
        <Text className={classes.cancellationPolicyText} tagName="p">
          {cancellationPolicy.guestPolicy}
        </Text>
      ) : null}
    </div>
  )
}
